module.exports = __webpack_public_path__ + "static/media/halal-logo.3124dc01.png";